
import Afterpay from './afterpay.vue'
import Price from '@/components/price/price.vue'
export default {
  components: { Price, Afterpay },
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
}
